import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'app-enroll-courses-dialog-box',
	standalone: true,
	imports: [RouterModule],
	templateUrl: './enroll-courses-dialog-box.component.html',
	styleUrl:'../../globalStyle/limit-dialog-box-common.scss'
})
export class EnrollCoursesDialogBoxComponent {


	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { title: string; message: string },
		private dialogRef: MatDialogRef<EnrollCoursesDialogBoxComponent>) { }

	close() {
		this.dialogRef.close();
	}
}